import { createSelector } from '@ngrx/store';
import * as fromReducers from '../reducers';

type SearchState = fromReducers.EntertainmentSearchState;

export const getEntertainmentSearchFeatureState = createSelector(
  fromReducers.getEntertainmentSearchState,
  (state: SearchState) => state
);

export const getEntertainmentSearchResultsLoading = createSelector(
  getEntertainmentSearchFeatureState,
  (state: SearchState) => state.results.isLoading
);

export const getEntertainmentSearchResultsError = createSelector(
  getEntertainmentSearchFeatureState,
  (state: SearchState) => state.results.error
);

export const getEntertainmentSearchResultsSearchPhrase = createSelector(
  getEntertainmentSearchFeatureState,
  (state: SearchState) => state.results.lastPhrase
);

export const getEntertainmentSearchResultsFilters = createSelector(
  getEntertainmentSearchFeatureState,
  (state: SearchState) => state.results.lastFilters
);

export const getEntertainmentSearchResultsPage = createSelector(
  getEntertainmentSearchFeatureState,
  (state: SearchState) => state.results.latestPage
);

export const getEntertainmentSearchResultsCanLoadMore = createSelector(
  getEntertainmentSearchFeatureState,
  (state: SearchState) => state.results.canLoadMore
);

export const getEntertainmentSearchResults = createSelector(
  getEntertainmentSearchFeatureState,
  (state: SearchState) => state.results.items
);

export const getEntertainmentPreferences = createSelector(
  getEntertainmentSearchFeatureState,
  (state: SearchState) => state.preferences
);
